export const getRelativeTime = (dateString?: string | null): string => {
  if (!dateString) return "";

  const created = new Date(dateString);
  if (isNaN(created.getTime())) return "";

  const now = new Date();
  const diffInMs = now.getTime() - created.getTime();

  if (diffInMs < 0) return "لحظاتی پیش";

  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInHours < 1) {
    return "لحظاتی پیش";
  } else if (diffInHours < 24) {
    return `${diffInHours} ساعت پیش`;
  } else if (diffInDays < 7) {
    return `${diffInDays} روز پیش`;
  } else if (diffInDays >= 7 && diffInDays <= 28) {
    const weeks = Math.floor(diffInDays / 7);
    return `${weeks} هفته پیش`;
  } else {
    return "بیش از 4 هفته پیش";
  }
};
